import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { categoryMap } from "../data/categoryMap";
import { db } from "../services/firebase"; 
import { doc, getDoc, updateDoc, collection, addDoc, serverTimestamp,getDocs, query, where } from "firebase/firestore";





const scaleLabels = {
  en: ["Completely disagree", "Somewhat disagree", "Somewhat agree", "Completely agree"],
  vn: ["Hoàn toàn không đồng ý", "Không đồng ý", "Đồng ý", "Hoàn toàn đồng ý"]
};


function shuffleArray<T>(array: T[]): T[] {
  return [...array].sort(() => Math.random() - 0.5);
}
function hasUnansweredQuestions(responses: { [index: number]: number }, total: number): boolean {
  return Object.keys(responses).length < total;
}

export default function InputForm() {
  const { code } = useParams();
  const [language, setLanguage] = useState<"en" | "vn">("vn");
  const [isManager, setIsManager] = useState(false);
  const [responses, setResponses] = useState<{ [index: number]: number }>({});
  const [resultsLink, setResultsLink] = useState<string | null>(null);
  const [isValidCode, setIsValidCode] = useState<boolean | null>(null);
  const [expiredMessage, setExpiredMessage] = useState<string | null>(null);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
const [showWarning, setShowWarning] = useState(false);
const [showManagerWarning, setShowManagerWarning] = useState(false);
const [managerBlockMessage, setManagerBlockMessage] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);



  const allStatements = categoryMap.flatMap((category) =>
    category.statements.map((statement) => ({
      id: statement.id,
      text: statement.text[language],
      categoryId: category.id,
      categoryName: category.name[language]
    }))
  );
const [shuffledStatementIds, setShuffledStatementIds] = useState<string[] | null>(null);

useEffect(() => {
  if (!shuffledStatementIds) {
    const randomOrder = shuffleArray(categoryMap.flatMap(c => c.statements.map(s => s.id)));
    setShuffledStatementIds(randomOrder);
  }
}, [shuffledStatementIds]);




  const handleResponseChange = (index: number, value: number) => {
    setResponses({ ...responses, [index]: value });
  };

const handleSubmit = async () => {
  if (!code) return;
  setIsSubmitting(true);

// Check if all questions are answered
if (!shuffledStatementIds || Object.keys(responses).length < shuffledStatementIds.length) {
  const confirmMsg =
    language === "en"
      ? "⚠️ You have not answered all questions. Are you sure you want to submit your answers?"
      : "⚠️ Bạn chưa trả lời tất cả câu hỏi. Bạn có chắc chắn muốn gửi phản hồi không?";

  const proceed = window.confirm(confirmMsg);
 if (!proceed) {
      setIsSubmitting(false);
      return;
    }
  }

  if (isManager) {
    try {
      const q = query(
        collection(db, "responses"),
        where("code", "==", code),
        where("isManager", "==", true)
      );
      const snap = await getDocs(q);
      if (!snap.empty) {
        setManagerBlockMessage(
  language === "en"
    ? "⚠️ A manager has already submitted a response. Please uncheck the box before submitting."
    : "⚠️ Một người quản lý đã gửi phản hồi. Vui lòng bỏ chọn ô trước khi gửi."
);
 setIsSubmitting(false);
        return;

      }
    } catch (err) {
      console.error("❌ Error checking existing manager during submission:", err);
      setIsSubmitting(false);
    }
  }
  try {
    const codeRef = doc(db, "codes", code);
    const codeSnap = await getDoc(codeRef);

    if (!codeSnap.exists()) {
      alert("This code does not exist. Please check again or contact support.");
       setIsSubmitting(false);
      return;
    }
// 🛠 INSERT NEW CHECK HERE

const q = query(collection(db, "responses"), where("code", "==", code));
const snap = await getDocs(q);

const allResponses = snap.docs.map(doc => doc.data());
const managerResponses = allResponses.filter(r => r.isManager);
const teamResponses = allResponses.filter(r => !r.isManager);

if (!isManager) {
  if (managerResponses.length === 0 && teamResponses.length >= 11) {
    alert(
      language === "en"
        ? "❌ Maximum number of team member submissions reached."
        : "❌ Đã đạt giới hạn thành viên nhóm."
    );
    setIsSubmitting(false);
    return;
  }
}
    // 🔁 Update firstUsedAt if it doesn't exist
    if (!codeSnap.data()?.firstUsedAt) {
      await updateDoc(codeRef, {
        firstUsedAt: serverTimestamp()
      });
    }

    const collectionRef = collection(db, "responses");

    const payload = {
      code,
      isManager,
    responses: Object.entries(responses).map(([key, score]) => {
  const index = parseInt(key);
  const statementId = shuffledStatementIds?.[index];
  const s = allStatements.find((stmt) => stmt.id === statementId);

  if (!s) return null;

  return {
    statementId: s.id,
    categoryId: s.categoryId,
    category: s.categoryName,
    text: s.text,
    score,
  };
}).filter(Boolean),

      submittedAt: serverTimestamp(),
    };

    await addDoc(collectionRef, payload);
      setConfirmationMessage(
  language === "en"
    ? "✅ Thank you for your response! The team results will be compiled soon."
    : "✅ Cảm ơn bạn đã phản hồi! Kết quả của nhóm sẽ sớm được tổng hợp."
);
setSubmitted(true);
    setIsSubmitting(false);
   setManagerBlockMessage(null);

    // ✅ Extra logic if this is a manager
    if (isManager) {
  const snap = await getDocs(query(collection(db, "responses"), where("code", "==", code)));
  const allResponses = snap.docs.map(doc => doc.data());
  const managers = allResponses.filter(r => r.isManager);
  const team = allResponses.filter(r => !r.isManager);

  // Always show the link
  setResultsLink(`https://teamscan.no-nonsense.management/results/${code}`);
}


  } catch (error) {
    console.error("Error submitting responses:", error);
    alert("There was an error submitting your responses.");
     setIsSubmitting(false);
  }
};

useEffect(() => {
  const validateCode = async () => {
    if (!code) return;

    try {
      const docRef = doc(db, "codes", code);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        setIsValidCode(false);
        return;
      }

      const data = docSnap.data();
      const firstUsedAt = data.firstUsedAt?.toDate?.();
      const now = new Date();

      if (firstUsedAt && now.getTime() - firstUsedAt.getTime() > 7 * 24 * 60 * 60 * 1000) {
        setIsValidCode(false);
        setExpiredMessage(
          `Your code is expired, it was activated at ${firstUsedAt.toLocaleDateString()}, and now it's more than 7 days later.`
        );
        return;
      }

      // ✅ Submission count check — inside async function!
      const q = query(collection(db, "responses"), where("code", "==", code));
      const snap = await getDocs(q);
      if (snap.size >= 12) {
        setIsValidCode(false);
        setExpiredMessage(
          language === "en"
            ? "❌ The maximum number of submissions is exceeded."
            : "❌ Đã vượt quá số lượng bài nộp tối đa."
        );
        return;
      }

      setIsValidCode(true);
    } catch (error) {
      console.error("Error validating code:", error);
      setIsValidCode(false);
    }
  };

  validateCode();
}, [code, language]);


  
  // ✅ EARLY RETURNS
if (isValidCode === false) {
  return (
    <div style={{ padding: "2rem", color: "red", fontWeight: "bold" }}>
      ❌ {expiredMessage || "This code is not valid. Please check your link or contact support."}
    </div>
  );
}



  if (isValidCode === null) {
    return <p style={{ padding: "2rem" }}>Validating code...</p>;
  }

  // ✅ MAIN FORM RENDER
  return (
  <div
    style={{
      maxWidth: "600px",
      margin: "0 auto",
      padding: "2rem",
      backgroundColor: "#f9f9f9",
      borderRadius: "10px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    }}
>
       <div style={{ textAlign: "center", marginBottom: "2rem" }}>
  <img
    src="/logo-nononsense.jpg"
    alt="No-Nonsense Coaching Logo"
    style={{ maxWidth: "180px", height: "auto" }}
  />
</div>
 
      <h2 style={{ textAlign: "center", fontSize: "1.8rem", marginBottom: "1rem" }}>
  High-Performing Team Framework
</h2>

   <p style={{ marginBottom: "1rem", fontWeight: "bold" }}>
  Are you the manager?
</p>
<label>
  <input
  type="checkbox"
  checked={isManager}
  onChange={async (e) => {
    const checked = e.target.checked;
    setIsManager(checked);

    if (checked) {
      try {
        const q = query(
          collection(db, "responses"),
          where("code", "==", code),
          where("isManager", "==", true)
        );
        const snap = await getDocs(q);
        if (!snap.empty) {
          setShowManagerWarning(true);
        } else {
          setShowManagerWarning(false);
        }
      } catch (err) {
        console.error("❌ Error checking manager presence:", err);
      }
    } else {
      setShowManagerWarning(false);
    }
  }}
/>
  I am the manager
</label>
{showManagerWarning && (
 <p style={{ color: "crimson", marginTop: "0.5rem", fontWeight: "bold" }}>
    {language === "en"
      ? "⚠️ A manager has already submitted. Please uncheck this box if you are not the original manager."
      : "⚠️ Một người quản lý đã gửi phản hồi. Vui lòng bỏ chọn ô nếu bạn không phải là người quản lý ban đầu."}
  </p>
)}

     <div style={{ margin: "1rem 0" }}>
  <button
    type="button"
    onClick={() => setLanguage(language === "en" ? "vn" : "en")}
    title={language === "en" ? "Chuyển sang Tiếng Việt" : "Switch to English"}
    style={{
      backgroundColor: "#0070f3",
    color: "#fff",
    padding: "0.75rem 1.5rem",
    fontSize: "1rem",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "2rem",
    width: "100%",
    fontWeight: "bold",
    }}
  >
    Language: {language === "en" ? "Tiếng Việt" : "English"}
  </button>
</div>
 

      <form>
     {shuffledStatementIds &&
  shuffledStatementIds.map((id, index) => {
    const statement = allStatements.find((s) => s.id === id);
    if (!statement) return null;
    return (
      <div key={index} style={{ marginTop: "1rem" }}>
        <p>{statement.text}</p>
        {[1, 2, 3, 4].map((num) => (
          <label
            key={num}
            style={{
              marginRight: "1.5rem",
              display: "inline-block",
              textAlign: "center",
            }}
          >
            <div>
              <input
                type="radio"
                name={`statement-${index}`}
                value={num}
                checked={responses[index] === num}
                onChange={() => handleResponseChange(index, num)}
              />
            </div>
            <div style={{ fontSize: "0.75rem", marginTop: "0.2rem", maxWidth: "80px" }}>
              {scaleLabels[language][num - 1]}
            </div>
          </label>
        ))}
      </div>
    );
  })}
      </form>

<button
  type="button"
  onClick={handleSubmit}
  disabled={isSubmitting || submitted}
  style={{
    marginTop: "2rem",
    padding: "0.5rem 1rem",
    fontSize: "1rem",
    backgroundColor: isSubmitting || submitted ? "#ccc" : "#0070f3",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: isSubmitting || submitted ? "not-allowed" : "pointer",
  }}
>
  {isSubmitting ? "Submitting..." : submitted ? "Submitted" : "Submit"}
</button>

    {managerBlockMessage && (
  <p style={{
    color: "crimson",
    marginTop: "1rem",
    padding: "0.75rem",
    backgroundColor: "#ffe6e6",
    border: "1px solid crimson",
    borderRadius: "4px",
    fontWeight: "bold", }}>
    {managerBlockMessage}
  </p>
)}

{submitted && (
  <p style={{ marginTop: "1rem", color: "green" }}>
    {language === "en"
      ? "✅ Thank you for your response, the team results will be compiled soon."
      : "✅ Cảm ơn bạn đã phản hồi, kết quả nhóm sẽ sớm được tổng hợp."}
  </p>
)}


{resultsLink && (
  <div style={{ marginTop: "1.5rem", padding: "1rem", border: "1px solid #ccc", borderRadius: "4px", backgroundColor: "#f9f9f9" }}>
    <p style={{ fontWeight: "bold" }}>
      {language === "en"
        ? "Your results page link:"
        : "Liên kết xem kết quả của bạn:"}
    </p>

    <p>
      <a href={resultsLink} target="_blank" rel="noopener noreferrer">{resultsLink}</a>
    </p>

    <p style={{ fontSize: "0.9rem", color: "#666", marginTop: "0.5rem" }}>
      {language === "en"
        ? "This link will only show results once at least 3 team members have submitted their responses."
        : "Liên kết này sẽ chỉ hiển thị kết quả sau khi có ít nhất 3 thành viên nhóm hoàn thành bài quét."}
    </p>
  </div>
)}


    </div>
  );
}
